<template>
  <div class="chat-history line-chat foo3">
    <div v-if="index===9" id="comment"></div>
    <li class="clearfix">
      <div :class="dataalign">        
        <div v-if="notSystemMessage" :class="headerIconClass" class="chat-avatar">
          <img v-bind:src="data.UserPicture" ref="headerIconImg" style="margin: 0;" />
        </div>
        <span v-if="notSystemMessage" class="message-username">{{ data.UserName }}</span>
        <span class="message-data-time">{{ data.msgTime }}</span>
        <ChatMessageText v-if="data.msgType === 'text'" :data="data" />
        <ChatMessageImage v-if="data.msgType === 'image'" :data="data" />
        <ChatMessageVedio v-if="data.msgType === 'video'" :data="data" />
        <ChatMessageFile v-if="data.msgType === 'file'" :data="data" />
      </div>
      <!-- <div v-if="senderType===2">
        <div class="message system-message" style="text-align: center;">
          <p>{{ data.Text}}</p>
        </div>
      </div> -->
    </li>
  </div>
</template>
<script>
import ChatMessageText from "../../components/Main/ChatMessageText";
import ChatMessageImage from "../../components/Main/ChatMessageImage";
import ChatMessageVedio from "../../components/Main/ChatMessageVedio";
import ChatMessageFile from "../../components/Main/ChatMessageFile";
import { HeaderIconHandler } from "@/handler/HeaderIconHandler.js";
// 聊天室訊息
export default {
  name: "ChatMessage",
  props: ["data", "index"],
  components: {
    ChatMessageText,
    ChatMessageImage,
    ChatMessageVedio,
    ChatMessageFile
  },
  created() {
    HeaderIconHandler.getImgSize(this.data.UserPicture).then(res=>{ 
      this.headerIconSizeObject = res;
      if(this.headerIconSizeObject.height > this.headerIconSizeObject.width){
        this.$refs.headerIconImg.style.margin = HeaderIconHandler.ComputeMarginVertical(this.headerIconSizeObject.width,this.headerIconSizeObject.height,50);
      }
      if(this.headerIconSizeObject.height < this.headerIconSizeObject.width){
        this.$refs.headerIconImg.style.margin = HeaderIconHandler.ComputeMarginHorizontal(this.headerIconSizeObject.width,this.headerIconSizeObject.height,50);
      }
    });
  },
  data() {
    return {
      headerIconSizeObject:{height:"",width:""}
    };
  },
  methods: {},
  computed: {
    senderType() {
      return this.data.senderType;
    },
    dataalign() {
      switch (this.data.senderType) {
        case 0:
          return "message-data align-right";
          break;
        case 1:
          return "message-data align-left";
          break;
        case 2:
          return "message system-message";
          break;
      }
    },
    notSystemMessage() {
      if (this.data.senderType == 2) {
        return false;
      } else {
        return true;
      }
    },
    headerIconClass(){
      return {
        MsgIconsquare: this.headerIconSizeObject.height == this.headerIconSizeObject.width,
        MsgIconvertical: this.headerIconSizeObject.height > this.headerIconSizeObject.width,
        MsgIconhorizontal: this.headerIconSizeObject.height < this.headerIconSizeObject.width
      };
    }
  }
};
</script>
<style>
.MsgIconvertical{
  top: 0 !important;
  position:absolute !important;
  width:50px !important;
  height:50px !important;
  overflow:hidden !important;
  border-radius:50% !important;
  display: inline-block !important;
}
.MsgIconvertical img{
  width:100% !important;
  height:auto !important;
}

.MsgIconhorizontal{
  top: 0 !important;
  display:inline-block !important;
  position:absolute !important;
  width:50px !important;
  height:50px !important;
  overflow:hidden !important;
  border-radius:50% !important;
  display: inline-block !important;
}
.MsgIconhorizontal img{
  width: auto !important;
  height: 100% !important;
}

.MsgIconsquare{
  top: 0 !important;
  position:absolute !important;
  display: inline-block !important;
}
.MsgIconsquare img{
  border-radius:50% !important;
  width:50px !important;
  height:50px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Main/ChatMessage.vue